import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function ResetPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { resetPassword } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    setLoading(true);

    try {
      await resetPassword(email);
      setMessage('パスワード再設定メールを送信しました。メールをご確認ください。迷惑メールフォルダもご確認ください。');
    } catch (err) {
      console.error('パスワードリセットエラー:', err);
      switch (err.code) {
        case 'auth/user-not-found':
          setError('このメールアドレスは登録されていません。');
          break;
        case 'auth/invalid-email':
          setError('メールアドレスの形式が正しくありません。');
          break;
        case 'auth/too-many-requests':
          setError('リクエストが多すぎます。しばらく時間を置いてから再度お試しください。');
          break;
        default:
          setError('メールの送信に失敗しました。もう一度お試しください。');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="card auth-card">
        <h2 className="text-center mb-4">パスワードを忘れた場合</h2>
        <p style={{ color: 'var(--gray)', marginBottom: '20px', fontSize: '0.95rem' }}>
          登録済みのメールアドレスを入力してください。パスワード再設定用のリンクをお送りします。
        </p>

        {message && <div className="alert" style={{ background: '#d4edda', color: '#155724', border: '1px solid #c3e6cb', padding: '15px', borderRadius: '8px', marginBottom: '20px' }}>{message}</div>}
        {error && <div className="alert alert-danger">{error}</div>}

        {!message && (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">メールアドレス</label>
              <input
                type="email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="example@domain.com"
                autoComplete="email"
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary w-100"
              disabled={loading}
            >
              {loading ? '送信中...' : '再設定メールを送信'}
            </button>
          </form>
        )}

        <div className="auth-links mt-4">
          <div className="text-center">
            <Link to="/login">ログインに戻る</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
